import {
  LF_CHANGE_LANGUAGE,
  LF_TOGGLE_MUTE,
  LF_SET_MUTE,
  LF_SET_ZOOM,
  LF_SET_TEXT_SIZE,
  LF_SET_VOLUME,
  LF_TOGGLE_SIDE_MENU_SLIDER_VISIBILITY,
  LF_SELECT_CHARACTER,
  LF_SELECT_CHARACTER_SECTION,
} from '../action-types/characters';
import { Language } from 'types/enums';
import getCharacterSet from '../static-data/get-character-set';

const initialState = {
  languageId: Language.ENGLISH,
  selectedCharacterSection: 'PRINT',
  muted: false,
  volumeLevel: 100,
  zoomLevel: 100,
  textSize: 100,
  selectedCharacterCategories: [],
  showSideMenuSlider: false,
  selectedCharacterItem: {
    character: '',
    svgPath: '',
    enabled: false,
    characterCase: '',
    characterType: '',
  },
};

export default function characters(state = initialState, action) {
  switch (action.type) {
    case LF_CHANGE_LANGUAGE: {
      return Object.assign({}, state, {
        languageId: action.languageId,
      });
    }

    case LF_SELECT_CHARACTER_SECTION: {
      return Object.assign({}, state, {
        selectedCharacterSection: action.characterSection,
      });
    }

    case LF_TOGGLE_MUTE: {
      return Object.assign({}, state, {
        muted: !state.muted,
      });
    }

    case LF_SET_MUTE: {
      return Object.assign({}, state, {
        muted: action.muted,
      });
    }

    case LF_SET_VOLUME: {
      return Object.assign({}, state, {
        volumeLevel: action.volume,
      });
    }

    case LF_SET_ZOOM: {
      return Object.assign({}, state, {
        zoomLevel: action.zoom,
      });
    }

    case LF_SET_TEXT_SIZE: {
      return Object.assign({}, state, {
        textSize: action.textSize,
      });
    }

    case LF_TOGGLE_SIDE_MENU_SLIDER_VISIBILITY: {
      return Object.assign({}, state, {
        showSideMenuSlider: action.show,
      });
    }

    case LF_SELECT_CHARACTER: {
      const { characterType, characterCase, character } = action;
      const characters = getCharacterSet(
        state.languageId,
        characterType,
        characterCase
      );

      return {
        ...state,
        selectedCharacterItem: characters.find(
          (c) => c.character === character
        ),
      };
    }

    default: {
      return state;
    }
  }
}
